import React from "react";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Email from "@mui/icons-material/Email";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Toolbar from "@mui/material/Toolbar";

import { Link } from "react-router-dom";


export default function Header() {
  return (
    <AppBar position="fixed">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <div className="header" style={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div className="my-name">
              <Link to="/" style={{ textDecoration: 'none', color: 'white', fontSize: '1.8rem', fontWeight: 'bold' }}>
                Elham Alassta
              </Link>
            </div>

            <div className="social-icon" style={{ display: 'flex', gap: '10px' }}>
              {/* LinkedIn */}
              <a
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/elham-alassta"
                target="_blank"
                aria-label="Elham Alassta's LinkedIn Profile"
                className="icon-link linkedin-bg"
              >
                <LinkedInIcon />
              </a>

              {/* GitHub */}
              {/*
              <a
                rel="noopener noreferrer"  
                href=""
                target="_blank"
                aria-label="Elham Alassta's GitHub Profile"
                className="icon-link github-bg" 
              >
                <GitHubIcon />
              </a>
            */}
              {/* Email */}
              <a
                rel="noopener noreferrer"
                href="mailto:ealassta@gmail.com"
                target="_blank"
                aria-label="Email Elham Alassta"
                className="icon-link email-bg"
              >
                <Email />
              </a>

              {/* WhatsApp */}
              <a
                rel="noopener noreferrer"
                href="https://wa.me/963935821242"
                target="_blank"
                aria-label="Contact Elham Alassta on WhatsApp"
                className="icon-link whatsapp-bg"
              >
                <WhatsAppIcon />
              </a>
            </div>
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
}